import type {
  LoyaltyBFFService,
  ILoyaltyBFFService,
  NetworkConfig,
  CreatingMemberPayload,
  LinkExistedMembershipParams,
  LoyaltyMember,
  LoyaltyTransactionResponse,
} from '@teko/loyalty';

class LoyaltyBFFServiceWrapper implements ILoyaltyBFFService {
  private clientId: string;
  private baseUrl: string;
  private service: LoyaltyBFFService | undefined;

  constructor(baseUrl: string, clientId: string) {
    this.baseUrl = baseUrl;
    this.clientId = clientId;
  }

  async initializeService() {
    if (!this.service) {
      const { LoyaltyBFFService } = await import('@teko/loyalty');
      this.service = new LoyaltyBFFService(this.baseUrl, this.clientId);
    }
    this.service.setClientId(this.clientId);
  }

  async setClientId(clientId: string) {
    this.clientId = clientId;
    if (!this.service) {
      await this.initializeService();
    } else {
      this.service.setClientId(clientId);
    }
  }

  getClientId(): string {
    return this.clientId;
  }

  async createMember(
    params: CreatingMemberPayload,
  ): Promise<{ memberId: string }> {
    await this.initializeService();
    return (this.service as LoyaltyBFFService).createMember(params);
  }

  async linkExistedMembership(
    params: LinkExistedMembershipParams,
  ): Promise<void> {
    await this.initializeService();
    return (this.service as LoyaltyBFFService).linkExistedMembership(params);
  }

  async getLoyaltyMemberInfo(): Promise<LoyaltyMember> {
    await this.initializeService();
    return (this.service as LoyaltyBFFService).getLoyaltyMemberInfo();
  }

  async getTransactionsHistory(
    txnType?: string,
    pageNumber?: number,
    pageSize?: number,
    fromTime?: string,
    toTime?: string,
  ): Promise<LoyaltyTransactionResponse> {
    await this.initializeService();
    return (this.service as LoyaltyBFFService).getTransactionsHistory(
      txnType,
      pageNumber,
      pageSize,
      fromTime,
      toTime,
    );
  }

  async getNetworkConfig(): Promise<NetworkConfig> {
    await this.initializeService();
    return (this.service as LoyaltyBFFService).getNetworkConfig();
  }
}

export default LoyaltyBFFServiceWrapper;
